import storage from "./storage";

class UserService {
  constructor() {}

  isUserAuthenticated() {
    if (typeof window !== "undefined") {
      // We are in the browser
      var token = this.getUserToken();
      if (token) {
        return true;
      }
    }
    return false;
  }

  cleanUserData() {
    storage.deleteUserData();
  }

  getUserToken() {
    if (!localStorage) {
      return null;
    }
    if (storage.getUserExpireDate()) {
      if (Date.now() > parseInt(storage.getUserExpireDate())) {
        this.deleteUserData(); // localStorage.removeItem("authData");
        return null;
      }
    } else {
      return null;
    }

    return storage.getUserToken();
  }

  setUserData(token) {
    var userExpireDate = Date.now() + 2 * 3600 * 1000;
    storage.saveUserToken(token);
    storage.setUserExpireDate(userExpireDate);
  }
}

const userService = new UserService();

export default userService;
